import { TbSearch } from 'solid-icons/tb';

interface SearchInputProps {
  value: string;
  onInput: (value: string) => void;
  placeholder?: string;
}

/**
 * Reusable SearchInput Component
 * Consistent search input styling across all pages
 */
export default function SearchInput(props: SearchInputProps) {
  return (
    <div class="p-4 md:p-6 border-b border-dashed border-gray-200 dark:border-gray-700">
      <div class="relative">
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <TbSearch size={20} class="text-gray-400" />
        </div>
        <input
          type="text"
          placeholder={props.placeholder || 'Search...'}
          value={props.value}
          onInput={(e) => props.onInput(e.currentTarget.value)}
          class="block w-full pl-10 pr-3 py-2 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-light-dark text-gray-900 dark:text-white placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand font-body"
        />
      </div>
    </div>
  );
}
